'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AccountService = function () {
  function AccountService($http) {
    'ngInject';

    _classCallCheck(this, AccountService);

    this.$http = $http;
  }

  _createClass(AccountService, [{
    key: 'getAccount',
    value: function getAccount(id) {
      return this.$http.get('/api/account/' + id);
    }
  }, {
    key: 'deleteAccount',
    value: function deleteAccount(id) {
      return this.$http.delete('/api/account/' + id);
    }
  }, {
    key: 'addAccount',
    value: function addAccount(account) {
      return this.$http.post('/api/account', account);
    }
  }, {
    key: 'updateAccount',
    value: function updateAccount(account) {
      return this.$http.put('/api/account/' + account.UserId, account);
    }
  }, {
    key: 'isUniqueUsername',
    value: function isUniqueUsername(username, id) {
      return this.$http.get('/api/account/unique_username', {
        params: {
          username: username,
          id: id
        }
      });
    }
  }, {
    key: 'changePassword',
    value: function changePassword(credentials) {
      return this.$http.post('/api/account/password_reset', credentials);
    }
  }, {
    key: 'forcePasswordChange',
    value: function forcePasswordChange(credentials) {
      return this.$http.post('/api/account/password_override', credentials);
    }
  }, {
    key: 'setLockoutStatus',
    value: function setLockoutStatus(userId, isLocked) {
      return this.$http.put('/api/account/' + userId + '/lockout', {
        userId: userId,
        isLocked: isLocked
      });
    }
  }, {
    key: 'updateDiscontinuedPreference',
    value: function updateDiscontinuedPreference(userId, showDiscontinuedProducts) {
      return this.$http.put('/api/account/' + userId + '/set_search_perference', {}, {
        params: {
          Is_Show_Discontiuned: showDiscontinuedProducts
        }
      });
    }
  }]);

  return AccountService;
}();

exports.default = AccountService;


// WEBPACK FOOTER //
// ./services/account.service.js